import { getStatus } from '@plug-core/handlers/walletActions/wallet'
import { WalletStatusResponse } from '@plug-core/interfaces/walletActions'
import { keychainManager } from '@plug-core/keyring'

export const subscribeToKeychainState = (callback: (state: WalletStatusResponse) => void) => {
  keychainManager.subscribe(async () => {
    const state = await getStatus()

    callback(state)
  })
}
